import React, { useEffect, useState } from 'react';
import './TronWalletModal.css';

const TronWalletModal = ({ wallet, isAdmin, onClose, onEnterMenu }) => {
  const [studentData, setStudentData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStudentData = async () => {
      try {
        // Get all students from localStorage
        const studentsData = JSON.parse(localStorage.getItem('students') || '[]');
        const attendanceData = JSON.parse(localStorage.getItem('attendance') || '[]');
        
        // Find student by wallet address
        const student = studentsData.find(s => 
          s.wallet?.toLowerCase() === wallet?.toLowerCase()
        );

        if (student) {
          // Calculate classes attended
          const studentAttendance = attendanceData.filter(a => 
            a.studentId === student.id || a.studentId === `${student.firstName}_${student.lastName}`
          );
          
          // Calculate MA+ tokens (attendance count)
          const maTokens = studentAttendance.length;
          
          // Get current month attendance for progress
          const now = new Date();
          const currentMonth = now.getMonth();
          const currentYear = now.getFullYear();
          const monthAttendance = studentAttendance.filter(a => {
            const date = new Date(a.date);
            return date.getMonth() === currentMonth && date.getFullYear() === currentYear;
          }).length;
          
          setStudentData({
            name: `${student.firstName} ${student.lastName}`,
            belt: student.belt || 'White',
            stripe: student.stripe || 0,
            classes: studentAttendance.length,
            maTokens: maTokens,
            monthProgress: monthAttendance,
            isPaying: student.isPaying || false,
            membershipType: student.membershipType || 'Trial'
          });
        } else {
          // No student found - might be new or admin
          setStudentData({
            name: 'New Member',
            belt: 'White',
            stripe: 0,
            classes: 0,
            maTokens: 0,
            monthProgress: 0,
            isPaying: false,
            membershipType: 'New'
          });
        }
      } catch (err) {
        console.error('Error fetching student data:', err);
        setStudentData(null);
      } finally {
        setLoading(false);
      }
    };

    if (wallet) {
      fetchStudentData();
    }
  }, [wallet]);

  const handleEnterMenu = () => {
    onEnterMenu?.();
    onClose?.();
  };

  if (loading) {
    return (
      <div className="tron-modal-overlay">
        <div className="tron-modal">
          <div className="tron-loading">
            <div className="tron-spinner"></div>
            <p>Loading profile...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="tron-modal-overlay" onClick={onClose}>
      <div className="tron-modal" onClick={(e) => e.stopPropagation()}>
        <div className="tron-modal-header">
          <div className="tron-title">
            WALLET CONNECTED
            {isAdmin && <span className="tron-admin-badge">🔱 ADMIN</span>}
          </div>
          <button className="tron-close" onClick={onClose}>✕</button>
        </div>

        <div className="tron-modal-body">
          {/* Wallet Address */}
          <div className="tron-wallet-address">
            <div className="tron-label">ADDRESS</div>
            <div className="tron-address-value">
              {wallet.substring(0, 6)}...{wallet.substring(wallet.length - 4)}
            </div>
          </div>

          {/* Student Info */}
          {studentData && (
            <>
              <div className="tron-student-name">{studentData.name}</div>
              
              <div className="tron-stats-grid">
                {/* Belt Rank */}
                <div className="tron-stat-card">
                  <div className="tron-stat-icon">🥋</div>
                  <div className="tron-stat-label">RANK</div>
                  <div className="tron-stat-value">
                    {studentData.belt}
                    {studentData.stripe > 0 && (
                      <span className="tron-stripe"> [{studentData.stripe}★]</span>
                    )}
                  </div>
                </div>

                {/* Total Classes */}
                <div className="tron-stat-card">
                  <div className="tron-stat-icon">📚</div>
                  <div className="tron-stat-label">CLASSES</div>
                  <div className="tron-stat-value">{studentData.classes}</div>
                </div>

                {/* MA+ Tokens */}
                <div className="tron-stat-card tron-highlight">
                  <div className="tron-stat-icon">⭐</div>
                  <div className="tron-stat-label">MA+ TOKENS</div>
                  <div className="tron-stat-value">{studentData.maTokens}</div>
                </div>

                {/* This Month */}
                <div className="tron-stat-card">
                  <div className="tron-stat-icon">📅</div>
                  <div className="tron-stat-label">THIS MONTH</div>
                  <div className="tron-stat-value">{studentData.monthProgress}</div>
                </div>
              </div>

              {/* Membership Status */}
              <div className={`tron-membership ${studentData.isPaying ? 'active' : 'trial'}`}>
                <div className="tron-membership-icon">
                  {studentData.isPaying ? '✓' : '○'}
                </div>
                <div className="tron-membership-text">
                  <div className="tron-membership-label">MEMBERSHIP</div>
                  <div className="tron-membership-type">{studentData.membershipType}</div>
                </div>
              </div>
            </>
          )}
        </div>

        <div className="tron-modal-footer">
          <button className="tron-btn tron-btn-secondary" onClick={onClose}>
            DISCONNECT
          </button>
          <button className="tron-btn tron-btn-primary" onClick={handleEnterMenu}>
            ENTER MENU →
          </button>
        </div>

        {/* Animated Border */}
        <div className="tron-border tron-border-top"></div>
        <div className="tron-border tron-border-right"></div>
        <div className="tron-border tron-border-bottom"></div>
        <div className="tron-border tron-border-left"></div>
      </div>
    </div>
  );
};

export default TronWalletModal;
